<!--
/*******************************************************************************
*@ 컴포넌트명   : SearchAcno.vue
*@ 컴포넌트설명 : 검색조건에 사용되는 계좌번호 selectbox - option template
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <span class="stit">{{data[2]}}</span>
    {{data[0]}} ({{data[1]}})
    <!-- <i class="icon icon-bookmark" v-if="isBookmark" /> -->
  </article>
</template>
<script>
export default {
  props: {
    isBookmark: {
      type: Boolean,
      default: false,
    },
    acno: String,
  },
  data() {
    return {
      data: [],
    };
  },
  beforeMount() {
    this.data = this.acno.split(";");
  },
};
</script>